import { Skeleton } from '@/components/ui';
import { formatEventDate } from '@/utils';
import React from 'react';

interface EventInfoHeaderProps {
  eventName: string | null;
  eventLocation: string | null;
  eventDate: string | null;
  loading: boolean;
}

export default function EventInfoHeader(
  event: EventInfoHeaderProps,
): React.ReactNode {
  return (
    <div className='flex w-full flex-col items-center justify-center gap-2 bg-zinc-950 p-6'>
      {!event.loading ? event?.eventDate && (
        <p className='text-sm font-medium text-white/70 md:text-base'>
          {formatEventDate(event?.eventDate)}
        </p>
        ) : (
          <Skeleton className='h-6 w-[10rem] bg-zinc-800 md:h-5' />
        )
      }
      <div className='flex flex-col items-center justify-center gap-2'>
        {!event.loading ? (
          <p className='text-center text-2xl font-semibold text-white md:text-2xl'>
            {event?.eventName}
          </p>
        ) : (
          <>
            <Skeleton className='h-6 w-[10rem] bg-zinc-800 md:h-5' />
          </>
        )}

        <div className='mx-auto flex flex-col items-center justify-center gap-2 rounded-xl text-white md:border-none md:p-0'>
          {!event.loading ? (
            <>
              <p className='max-w-300 text-center text-sm font-medium text-white/80 md:text-base'>
                {event.eventLocation}
              </p>
            </>
          ) : (
            <>
              <Skeleton className='h-6 w-[10rem] bg-zinc-800' />
            </>
          )}
        </div>
      </div>
    </div>
  );
}
